import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { HasOwner } from '../../../entities/activity/activity-owner-dto';

@Component({
    selector: 'app-activity-owner-badge',
    template: `
    @if(shouldShowBadge()) {
      <div class="inline-flex items-center gap-1 px-2 py-1 rounded bg-[#e3f2fd] text-[#1565c0] text-[11px] leading-[11px]">
        ↳ Von <span class="cursor-pointer hover:underline"
        [nxNewTabNavigation]="[getCollectionPage(owner()), owner()?.id]"
        [queryParams]="owner()?.ownerType !== 'Order' ? { type: getQueryParam(owner()), show: owner()?.id } : undefined">{{translateEntityType(owner()?.ownerType)}} {{owner()?.label}}</span>
      </div>
    }
  `
})
export class ActivityOwnerBadgeComponent {

    private readonly router = inject(Router);
    readonly owner = input<HasOwner>();
    readonly ownerId = input<string>();

    private readonly entityTypeTranslations: Record<string, string> = {
        'Resource': 'Ressource',
        'Task': 'Aufgabe',
        'Contact': 'Kunde',
        'Order': 'Auftrag',
        'Issue': 'Vorgang'
    };

    readonly shouldShowBadge = computed(() => {
        const owner = this.owner();
        const ownerId = this.ownerId();
        return owner && owner.id && owner.id !== ownerId;
    });

    translateEntityType(type: string): string {
        return this.entityTypeTranslations[type] ?? type;
    }

    getCollectionPage(link: HasOwner): string {
        if (link?.ownerType === 'Order') {
            return `/orders/order`;
        }
        if (link?.ownerType === 'Task') {
            return `/tasks/task`;
        }
        if (link?.ownerType === 'Issue') {
            return `/issues/issue`;
        }
        return '';
    }

    getQueryParam(link: HasOwner): string {
        if (link?.ownerType === 'Order') {
            return `order`;
        }
        if (link?.ownerType === 'Task') {
            return `task`;
        }
        if (link?.ownerType === 'Issue') {
            return `issue`;
        }
        return '';
    }
}
